export class SharedConstants {
    // Filter labels
    static FILTER_BY_DEFAULT = "All columns";
    static NO_ITEMS_AVAILABLE_MESSAGE = "There are no items to display";
    static NO_FILTER_RESULTS = "Filter yielded no results"; // Shows when no results from a search in the table
    static FILTER_BY_PLACEHOLDER = "Filter by none";
    static FILTER_ITEMS_PLACEHOLDER = "Filter items";
    static FILTER_PREFIX = "Filter by";
    static SEARCH_PREFIX = "Search"; // Placeholder on table search
    static FILTER_DEFAULT = "All"; // used on recipients select and recipients list filters
    static NO_FILTER_SELECTED_MESSAGE = "Please select a filter option";
    static PLACEHOLDER_TEXT = "Please select an option"; // Dropdown place holder used dropdowns
    static EXCLUDE_HEADING_ACTIONS = "Actions";
    static SYSTEM_DATE_FORMAT_DEFAULT = "yyyy/MM/dd";
    static INVALID_TABLE_VALUE_ERROR = "Invalid table value exists";
    static TABLE_COLUMN_MAPPING_EXISTS_ERROR = "No column-to-item property mapping exists for table";
    /* Search Filter */
    static SEARCH_NOT_BLANK = "Search criteria may not be blank";
    static ENTER_FILENAME_LABEL = "Enter filename";
    static YES_LABEL = "Yes";
    static NO_LABEL = "No";
    static REQUIRED_INPUT_CONTROL_VALIDATION = "is required.";
}
